// extracted by mini-css-extract-plugin
export default {"root":"FileInfoModal__root--qjPzc","content":"FileInfoModal__content--1Qqs3","header":"FileInfoModal__header--2i766","item":"FileInfoModal__item--2dGXn"};